// localStorage with schema versioning + migration scaffold (#3).
// Bump SCHEMA_VERSION when key shape changes; add a case to migrate().

import { GMV_ACT } from './constants.js';
import { ROLE_PINS } from './roles.js';
import { state } from './state.js';

export const SCHEMA_VERSION = 2;

// Versioned keys: hd:v2:actuals, hd:v2:bonus, etc.
const ns = (k) => `hd:v${SCHEMA_VERSION}:${k}`;
export const K = {
  ACT:       ns('actuals'),
  BONUS:     ns('bonus'),
  ROLE:      ns('role'),
  IMPORT_DAY:ns('import_day'),
  GMV:       ns('gmv_act'),
  PIN_CUSTOM:ns('role_pins_custom'),
  EMAILS:    ns('role_emails'),
  FC_CUSTOM: ns('gmv_fc_custom'),
};

// Legacy keys (pre-v2) — migrated then deleted
const LEGACY = {
  hd_act_2026:           K.ACT,
  hd_bonus_2026:         K.BONUS,
  hd_role_2026:          K.ROLE,
  hd_import_day:         K.IMPORT_DAY,
  hd_gmv_act_2026:       K.GMV,
  hd_role_pins_custom:   K.PIN_CUSTOM,
  hd_role_emails:        K.EMAILS,
  hd_gmv_fc_custom:      K.FC_CUSTOM,
};

function safeGet(k)    { try { return localStorage.getItem(k); } catch { return null; } }
function safeSet(k, v) { try { localStorage.setItem(k, v); } catch {} }
function safeDel(k)    { try { localStorage.removeItem(k); } catch {} }

/** Migrate any legacy keys forward; idempotent. Call once at boot. */
export function migrate() {
  for (const [oldKey, newKey] of Object.entries(LEGACY)) {
    const v = safeGet(oldKey);
    if (v != null && safeGet(newKey) == null) safeSet(newKey, v);
    if (v != null) safeDel(oldKey);
  }
}

export function loadFromStorage() {
  try {
    const a = safeGet(K.ACT); if (a) Object.assign(state.actuals, JSON.parse(a));
    const b = safeGet(K.BONUS); if (b) Object.assign(state.bonusInputs, JSON.parse(b));
    const g = safeGet(K.GMV);
    if (g) {
      const parsed = JSON.parse(g);
      ['CAR', 'HELI', 'JET'].forEach((bu) => {
        if (parsed[bu]) GMV_ACT[bu] = parsed[bu];
      });
    }
    const e = safeGet(K.EMAILS); if (e) Object.assign(state.ROLE_EMAILS, JSON.parse(e));
    const p = safeGet(K.PIN_CUSTOM); if (p) Object.assign(ROLE_PINS, JSON.parse(p));
  } catch (e) {
    console.warn('[storage] load failed', e);
  }
}

export const saveActuals    = () => safeSet(K.ACT,    JSON.stringify(state.actuals));
export const saveGMVAct     = () => safeSet(K.GMV,    JSON.stringify(GMV_ACT));
export const saveBonusInputs= () => safeSet(K.BONUS,  JSON.stringify(state.bonusInputs));
export const saveEmails     = () => safeSet(K.EMAILS, JSON.stringify(state.ROLE_EMAILS));
export const saveRole       = (key) => safeSet(K.ROLE, key);
export const loadSavedRole  = () => safeGet(K.ROLE);
export const saveImportDay  = (day, month) =>
  safeSet(K.IMPORT_DAY, JSON.stringify({ day, month, ts: Date.now() }));
export const loadImportDay  = () => {
  const v = safeGet(K.IMPORT_DAY);
  return v ? JSON.parse(v) : null;
};
